var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-info',{on:{"mbBodytop":_vm.getmbBodytop,"reviewtop":_vm.getreviewtop}})
}
var staticRenderFns = []

export { render, staticRenderFns }